import { qs, listen, toggle, add, remove } from '@fluorescent/dom';

import { section } from '@/glow';
import filterHandler from '@/lib/filters/filter-handler';
import filterDrawer from '@/lib/filters/filter-drawer';

const selectors = {
  partial: '[data-partial]',
  loader: '.search__loading',
};

const classes = {
  active: 'is-active',
};

section('search', {
  onLoad() {
    const clearButton = qs('[data-clear-search]', this.container);
    const searchButton = qs('.search__submit', this.container);
    const searchInput = qs('[data-search-input]', this.container);
    const filterForm = qs('[data-filter-form]', this.container);
    this.searchParamsInitial = window.location.search.slice(1);
    this.searchParamsPrev = window.location.search.slice(1);

    if (filterForm) {
      this.partial = qs(selectors.partial, this.container);

      this.filterDrawer = filterDrawer(this.container);
      this.filterHandler = filterHandler({
        container: this.container,
        partial: this.partial,
        renderCB: this._renderView.bind(this),
      });
    }

    toggle([clearButton, searchButton], 'visible', searchInput.value !== '');

    this.events = [
      listen(clearButton, 'click', () => {
        searchInput.value = '';
        toggle(
          [clearButton, searchButton],
          'visible',
          searchInput.value !== ''
        );
      }),
      listen(searchInput, 'input', e =>
        toggle([clearButton, searchButton], 'visible', e.target.value !== '')
      ),
      listen(window, 'popstate', event => {
        const searchParams = event.state
          ? event.state.searchParams
          : this.searchParamsInitial;
        if (searchParams === this.searchParamsPrev) return;
        this._renderView(searchParams, false);
      }),
    ];
  },

  _renderView(searchParams, updateHash = true) {
    const url = `${window.location.pathname}?section_id=${this.container.dataset.sectionId}&${searchParams}`;
    const loading = qs(selectors.loader, this.container);

    add(loading, classes.active);
    this.filterDrawer.unload();

    fetch(url)
      .then(res => res.text())
      .then(res => {
        this.searchParamsPrev = searchParams;
        updateHash && this._updateURLHash(searchParams);
        const doc = new DOMParser().parseFromString(res, 'text/html');
        const contents = qs(selectors.partial, doc).innerHTML;
        this.partial.innerHTML = contents;

        remove(loading, classes.active);
        this.filterDrawer = filterDrawer(this.container);
      });
  },

  _updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
  },

  onUnload() {
    this.buttonHandler();
    this.filterHandler && this.filterHandler.unload();
    this.filterDrawer && this.filterDrawer.unload();
  },
});
